import {IRequestPromoCode, IRequestPromoCodeData, RequestPromoCodeStatus} from "./index";
import {PromoCode} from "../..";

export class RequestPromoCode extends PromoCode implements IRequestPromoCode {
  readonly name: string;
  readonly status: RequestPromoCodeStatus;
  readonly stripe_product: string
  readonly stripe_price: string

  constructor(data: IRequestPromoCodeData) {
    super(data);
    this.name = data.name;
    this.status = data.status || 'new';
    this.stripe_product = data.stripe_product;
    this.stripe_price = data.stripe_price;
  }
}